/**
 * Debounce a class function.
 * You may need to run `detectChanges` from your ChangeDetectorRef within the class function to trigger a change detection cycle.
 * @param {number} delay
 * @returns {MethodDecorator}
 * @constructor
 */
export function Debounce(delay: number = 300): MethodDecorator {
    return function (
        target: any,
        propertyKey: string,
        descriptor: PropertyDescriptor
    ) {
        let timeout = null;

        const original = descriptor.value;

        descriptor.value = function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                original.apply(this, args);
            }, delay);
        };

        return descriptor;
    };
}